import type { SearchResponse } from '@/services/executives/response.interface'

import type {
    CategoryType,
    ITenantSearchResponse,
    ServiceType,
} from '../../types'
import { baseApi } from '../baseApi'
import type {
    IDashboardData,
    ITenantUser,
    ResponseType,
    ServiceFormType,
    ServicesByIDResponeDataType,
} from '../types'

const webBase = 'api/tenants'

export const webPageApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getDashboardTenant: builder.query<ResponseType<IDashboardData>, string>(
            {
                query: qwery => `${webBase}/dashboard?${qwery}`,
            },
        ),
        getAnalytics: builder.query<ResponseType<any>, void>({
            query: () => `${webBase}/analytics`,
        }),
        getSettings: builder.query<ResponseType<any>, void>({
            query: () => `${webBase}/settings`,
        }),
        getServicesList: builder.query<ResponseType<ServiceType[]>, string>({
            query: qwery => `${webBase}/services?${qwery}`,
            providesTags: ['service'],
        }),
        createService: builder.mutation<ResponseType<ServiceType>, FormData>({
            query: body => ({
                url: `${webBase}/services`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['service'],
        }),
        updateService: builder.mutation<
            ResponseType<ServiceType>,
            { serviceId: string; body: FormData }
        >({
            query: ({ serviceId, body }) => ({
                url: `${webBase}/services/${serviceId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['service'],
        }),
        deleteService: builder.mutation<ResponseType<ServiceFormType>, number>({
            query: serviceId => ({
                url: `${webBase}/services/${serviceId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['service'],
        }),
        getServicesById: builder.query<
            ResponseType<ServicesByIDResponeDataType>,
            string
        >({
            query: id => `${webBase}/services/${id}`,
        }),
        getCategories: builder.query<ResponseType<CategoryType[]>, void>({
            query: () => `api/admin/categories`,
        }),
        getTenantSearch: builder.query<
            ResponseType<ITenantSearchResponse>,
            string
        >({
            query: query => `${webBase}/search?search=${query}`,
        }),
    }),
})

export const {
    useGetDashboardTenantQuery,
    useGetAnalyticsQuery,
    useGetSettingsQuery,
    useCreateServiceMutation,
    useDeleteServiceMutation,
    useUpdateServiceMutation,
    useGetCategoriesQuery,
    useGetServicesByIdQuery,
    useGetServicesListQuery,
    useLazyGetServicesListQuery,
    useGetTenantSearchQuery,
} = webPageApi
